"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const pile_1 = require("./pile");
const player_1 = require("./player");
const card_1 = require("./card");
const hand_1 = require("./hand");
const table_1 = require("./table");
const actionability_resolver_1 = require("./actionability-resolver");
const demystifier_1 = require("./demystifier");
const errors_1 = require("./errors");
function refineHand(turn, getMaskedHandIdx) {
    // NB: turn does not include own hand cards that are resolved
    const getRevealedCards = (...excludePlayerIndices) => [
        // discard pile
        turn.discardPile.cards,
        // table
        turn.table.getCards(),
        // hands of other players
        turn.maskedPlayerViews.filter((_, idx) => !excludePlayerIndices.includes(idx)).flatMap(mh => mh.hand),
    ].flat(); // 'as any' as a tmp fix, TODO: check this later
    const meIdx = turn.maskedPlayerViews.findIndex(mh => mh.isMe);
    const { hand } = turn.maskedPlayerViews[getMaskedHandIdx];
    const [myDemystifiedHand, myCardsRevealedToMe] = demystifier_1.demystify(turn.maskedPlayerViews[meIdx].hand.map(c => new card_1.MaskedCard({ hints: c.hints })), // remove all existing derived information
    getRevealedCards(meIdx), turn._gameParams);
    // console.warn('mDH', ...myDemystifiedHand)
    const demystifyOtherHand = () => {
        // console.warn(
        //   111,
        //   hand.map(c => c.hints),
        // )
        return demystifier_1.demystify(hand.map(c => new card_1.MaskedCard({ hints: c.hints })), [...myCardsRevealedToMe, ...getRevealedCards(meIdx, getMaskedHandIdx)], turn._gameParams)[0];
    };
    if (turn.maskedPlayerViews[getMaskedHandIdx].isMe) {
        return actionability_resolver_1.resolveActionability(myDemystifiedHand, turn.table, turn.discardPile);
    }
    else {
        // mystery view
        return actionability_resolver_1.resolveActionability(demystifyOtherHand(), turn.table, turn.discardPile);
    }
}
exports.refineHand = refineHand;
class BaseTurn {
    constructor(t, players, gameParams) {
        this.status = t.status;
        this.action = t.action;
        this.discardPile = new pile_1.Pile(t.discardPile.map(c => card_1.Card.fromValueString(c)));
        this.hintCount = t.hintCount;
        this.woundCount = t.woundCount;
        this.table = new table_1.Table(t.table, gameParams);
        this.turnNumber = t.turnNumber;
        this._gameParams = gameParams;
        this.turnsLeft = typeof t.turnsLeft !== 'undefined' ? t.turnsLeft : null;
        this.timestamp = t.timestamp || new Date().toISOString();
        this._players = players.map(p => new player_1.Player(p));
    }
    get score() {
        return this.table.getScore();
    }
}
exports.BaseTurn = BaseTurn;
class Turn extends BaseTurn {
    constructor(t, players, gameParams) {
        super(t, players, gameParams);
        this.hands = t.hands.map(p => new hand_1.Hand(p));
        this.stock = new pile_1.Pile(t.stock);
    }
    clone() {
        // make a deep copy
        return new Turn(JSON.parse(JSON.stringify(this.toJSON())), this._players, this._gameParams);
    }
    get inTurn() {
        return this.turnNumber % this._players.length;
    }
    toJSON() {
        return Object.assign(Object.assign({}, this), { _players: undefined, _gameParams: undefined, stock: this.stock.toJSON(), discardPile: this.discardPile.toJSON(), table: this.table.toJSON(), hands: this.hands.map(p => p.toJSON()) });
    }
    get stockSize() {
        return this.stock.cards.length;
    }
    _getMaskedHands(meIdx) {
        // NB: this does not include own hand cards that are resolved
        return this.hands.map((ch, idx) => idx === meIdx
            ? {
                isMe: true,
                hand: ch.cards.map(c => new card_1.MaskedCard({ hints: c.hints })),
            }
            : {
                isMe: false,
                hand: ch.cards.map(c => new card_1.MaskedCard({ color: c.color, num: c.num, hints: c.hints })),
            });
    }
    getState(forPlayerId) {
        const me = this._players.find(p => p.id === forPlayerId);
        const isOutsider = !me;
        return JSON.parse(JSON.stringify(Object.assign(Object.assign({}, this.toJSON()), { 
            /// remove these:
            _players: undefined, hands: undefined, stock: undefined, 
            ///
            stockSize: this.stock.size, inTurn: this.inTurn, score: this.score, maskedPlayerViews: isOutsider
                ? [] // this.players.map(p => MaskedPlayer.outsiderFromPlayer(p))
                : this._getMaskedHands(me.idx) })));
    }
    playAction(playerId, actionParams, { maxHintCount, maxWoundCount }) {
        // console.warn(1234, {
        //   type: actionParams.type,
        //   playerId,
        //   inTurn: this.inTurn,
        //   players: this.players,
        //   turnNumber: this.turnNumber,
        // })
        const newTurn = this.clone();
        // get current player
        const me = newTurn._players[newTurn.inTurn];
        if (!me) {
            throw new errors_1.GameError('NO_SUCH_PLAYER', { playerId });
        }
        if (playerId !== me.id) {
            throw new errors_1.GameError('NOT_MY_TURN', { playerId });
        }
        if (newTurn.status !== 'RUNNING') {
            // console.warn(nextTurn)
            throw new errors_1.GameError('GAME_ENDED');
        }
        if (actionParams.type === 'START') {
            if (this.turnNumber > 0) {
                throw new errors_1.GameError('ALREADY_STARTED');
            }
            newTurn.action = actionParams;
        }
        else if (actionParams.type === 'HINT') {
            if (!['A', 'B', 'C', 'D', 'E', 1, 2, 3, 4, 5].includes(actionParams.is)) {
                throw new errors_1.GameError('NO_HINTS_OUTSIDE_ABCDE12345');
            }
            if (!newTurn.hintCount) {
                throw new errors_1.GameError('NO_HINTS_LEFT');
            }
            newTurn.hintCount--;
            const hintee = newTurn._players[actionParams.toPlayerIdx];
            if (!hintee) {
                throw new errors_1.GameError('NO_SUCH_PLAYER', actionParams.toPlayerIdx);
            }
            if (hintee === me) {
                throw new errors_1.GameError('CANNOT_HINT_SELF');
            }
            newTurn.hands[hintee.idx].addHint({ turnNumber: newTurn.turnNumber, is: actionParams.is });
            newTurn.action = Object.assign(Object.assign({}, actionParams), { toPlayerName: hintee.name, matches: newTurn.hands[hintee.idx].cards.map(c => c.hints[c.hints.length - 1].result) });
        }
        else {
            // PLAY or DISCARD
            const card = newTurn.hands[me.idx].take(actionParams.cardIdx, newTurn.stock);
            if (actionParams.type === 'PLAY') {
                const playResult = newTurn.table.play(card);
                if (playResult === 'SUCCESS_CLOSED') {
                    if (newTurn.hintCount < maxHintCount) {
                        newTurn.hintCount++;
                    }
                    if (newTurn.score === card_1.getAllColors(this._gameParams).length * card_1.AllNums.length) {
                        newTurn.status = 'FINISHED';
                    }
                }
                else if (playResult === 'FAILURE') {
                    // fail: add wound
                    newTurn.discardPile.add(card); // TODO: add metadata?
                    newTurn.woundCount++;
                    // TODO: log
                    if (newTurn.woundCount === maxWoundCount) {
                        newTurn.status = 'GAMEOVER';
                    }
                }
                newTurn.action = Object.assign(Object.assign({}, actionParams), { card: card.toJSON(), success: playResult !== 'FAILURE' });
            }
            else if (actionParams.type === 'DISCARD') {
                if (newTurn.hintCount === maxHintCount) {
                    throw new errors_1.GameError('CANNOT_DISCARDS_WHEN_MAX_HINTS');
                }
                newTurn.hintCount++;
                newTurn.discardPile.add(card);
                newTurn.action = Object.assign(Object.assign({}, actionParams), { card: card.toJSON() });
            }
        }
        // actually change the turn:
        newTurn.timestamp = new Date().toISOString();
        newTurn.turnNumber++;
        if (newTurn.turnsLeft !== null)
            newTurn.turnsLeft--;
        if (newTurn.turnsLeft === 0) {
            // NB: don't change a GAMEOVER (on the last possible turn) to FINISHED
            if (newTurn.status === 'RUNNING') {
                newTurn.status = 'FINISHED';
            }
        }
        else if (!newTurn.stock.size && newTurn.turnsLeft === null) {
            // countdown should start now
            newTurn.turnsLeft = newTurn._players.length;
        }
        return newTurn;
    }
}
exports.Turn = Turn;
//# sourceMappingURL=turn.js.map